import styled from "styled-components";

export const BackSVG = styled.svg`
  margin: 26px 0 26px 0;
  pointer-events: none;
`;

export const Button = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`;
